import FieldProto from "../field-proto";

import SettingsForm from "./components/settings-form";
import FormElement from "./components/form-element";


export default class FormFieldDate extends FieldProto {

    constructor(config) {
        super(config);

        this.type = gd.const.formFields.type.DATE;
    }

    getSettingsForm() {
        return SettingsForm.bind(null, this); // null is needed here as firt argument as it dfines the scope! and second arg is realy arg
    }

    getFormElement() {
        return FormElement.bind(null, this);
    }

    valueToString(value) {
        let strValue = '';
        if (value) strValue = value.format('YYYY-MM-DD');
        return strValue;
    }

}